import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@artosera/ui';
import { evenementsApi, useActionEvenement, type CorpsEvenement } from '../../api/evenements.js';
import { estApiError } from '../../api/errors.js';
import { useShellContext } from '../shell/context.js';
import { FormulaireEvenement } from './FormulaireEvenement.js';

export function NouvelEvenementDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug } = useShellContext();
  const navigate = useNavigate();
  const creation = useActionEvenement(galerieSlug, (corps: CorpsEvenement, appel) =>
    evenementsApi.creer(galerieSlug, corps, appel),
  );
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('evenements.nouveau')}
      closeLabel={t('commun:actions.fermer')}
    >
      <FormulaireEvenement
        occupe={creation.isPending}
        onEnregistrer={(corps) =>
          creation.mutate(corps, {
            onSuccess: ({ evenement }) => {
              onOpenChange(false);
              navigate(`/${galerieSlug}/evenements/${evenement.id}`);
            },
          })
        }
      />
      {creation.isError ? (
        <p role="alert">
          {estApiError(creation.error) ? creation.error.message : t('commun:erreurReseau')}
        </p>
      ) : null}
    </Dialog>
  );
}
